// extracted by mini-css-extract-plugin
module.exports = {"soloChatRoutes":"solo-chat-routes_soloChatRoutes__n8-q6","routes":"solo-chat-routes_routes__lZxjA"};